import './reset.css'
import 'antd/dist/antd.css'
import React from 'react'
import ReactDOM from 'react-dom'
import reportWebVitals from './reportWebVitals'
import { HashRouter, BrowserRouter } from 'react-router-dom'
import { AuthProvider } from 'context/AuthContext'
import { GlobalStateProvider } from 'context/GlobalStateContext'
import { ApolloClient, InMemoryCache } from '@apollo/client'
import { ApolloProvider } from '@apollo/client/react'
import { App } from './App'

const backend = process.env.REACT_APP_BACK_END_URL
const client = new ApolloClient({
  uri: `${process.env.NODE_ENV === 'production' ? backend : ''}/graphql`,
  credentials: 'include',
  cache: new InMemoryCache({
    typePolicies: {
      ConcreteTest: { keyFields: ['globalId'] },
      PacketFile: { keyFields: ['sharePointItemId'] },
    },
  }),
})

const Router: React.FC = ({ children }) => {
  if (process.env.NODE_ENV === 'production')
    return (
      <BrowserRouter basename={process.env.REACT_APP_SUBDIRECTORY}>
        {children}
      </BrowserRouter>
    )
  return <HashRouter basename="/">{children}</HashRouter>
}

ReactDOM.render(
  <React.StrictMode>
    <ApolloProvider client={client}>
      <Router>
        <AuthProvider>
          <GlobalStateProvider>
            <App />
          </GlobalStateProvider>
        </AuthProvider>
      </Router>
    </ApolloProvider>
  </React.StrictMode>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
